import React from 'react';
import { useParams } from 'react-router-dom';
import FraseDay from '../components/frase_day/Frase_Day';
import SignGrid from '../components/sign_grid/SignGrid';

const Frase = () => {
  const { signo } = useParams();

  return (
    <div className="App">
      {signo ? <FraseDay sign1={signo} /> : <SignGrid />}
    </div>
  );
};

export default Frase;